import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { clientAccess } from "../../utils/index";
import CommercialClausesTable from "./CommercialClausesTable";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import Select from "react-select";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};


class CommercialClauses extends React.Component {
  state = {
    url: `${apiUrl.apiUrl.url}/commercial-clause/create`,
    LandlordGroups: [],
    clientList: [],
    isOpen: false,
    redirect: false,
    messsagePopup: false,
    popupContent: "",
    popupalertMessage: false,
    popupMessageContent: '',
    delete: false,
    id: undefined,
    initialValues: {
      groupId: "",
      groupName: "",
      clientId: "",
      clientName: "",
      clause_name: "",
      effective_from: "",
    },
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {

    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/commercial-clause/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        console.log('you cannot delete');
      } else {
        // if (window.confirm("Are You Sure You Want to Delete the item?")) {
        //   axios({
        //     method: "get",
        //     url: `${apiUrl.apiUrl.url}/commercial-clause/delete?id=${self.state.id}`,
        //   }).then(function (response) {
        //     if (!response.data.success) {
        //       alert("Something Went Wrong");
        //     } else {
        //       alert("Data Deleted Successfully");
        //       self.setState({ redirect: true });
        //     }
        //   });
        // }
        self.setState({
          delete: true,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/commercial-clause/create`,
          initialValues: {
            clause_name: "",
            effective_from: "",
            groupId: "",
            groupName: "",
            clientId: "",
            clientName: "",
          },
        });
      } else {
        let athis = this;
        axios.get(`${apiUrl.apiUrl.url}/commercial-clause/fetch-logic?id=${this.props.match.params.id}`).then((response) => {
          let data = response.data;
          athis.setState({
            url: `${apiUrl.apiUrl.url}/commercial-clause/update?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            LandlordGroups: data.LandlordGroups,
            clientList: data.clientList,
            //
          });
        }).catch((err) => {});

        // fetch(
        //   `${apiUrl.apiUrl.url}/commercial-clause/fetch-logic?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/commercial-clause/update?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       LandlordGroups: data.LandlordGroups,
        //       clientList: data.clientList,
        //       //
        //     });
        //     console.log(this.state.initialValues);
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }
  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        clause_name: "",
        effective_from: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        clause_name: "",
        effective_from: "",
      },
    });
  };

  redirectToDelete = () => {
    this.setState({
      delete: false,
    });
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/commercial-clause/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        // alert("Something Went Wrong");
        self.setState({
          popupalertMessage: true,
          popupMessageContent: 'Something Went Wrong',
        });
      } else {
        // alert("Data Deleted Successfully");
        self.setState({
          messsagePopup: true,
          popupContent: 'Data Deleted Successfully'
        });
      }
    });
  };
  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: '',
    });
  };

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
    console.log(this.groupId, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };


  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/commercial-clauses" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/charges-master">Charges Master</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">Commercial Clauses</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            console.log(values);
            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                // alert("Data Saved Successfully");
                actions.setSubmitting(false);

                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: 'Data Saved Successfully'
                });
                // self.setState({ redirect: true });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Group <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientGroup"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(e, "change_client_group");
                              }}
                              value={{
                                label: this.state.initialValues.groupName,
                                value: this.state.initialValues.groupId,
                              }}
                              options={this.state.LandlordGroups.map((item) => ({
                                label: item.group_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="clientGroup"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      )}

                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Name <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientName"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(e, "change_client_name");
                              }}
                              value={{
                                label: this.state.initialValues.clientName,
                                value: this.state.initialValues.clientId,
                              }}
                              options={this.state.clientList.map((item) => ({
                                label: item.client_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="clientName"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      )}

                      <div className="newGridSectionInner">
                        <label>
                          Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="clause_name" />
                          <ErrorMessage
                            name="clause_name"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Effective From <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="date" name="effective_from" />
                          <ErrorMessage
                            name="effective_from"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}>
                          Delete
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          <Link to="/masters/commercial-clauses">
                            Reset
                          </Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="add_button" disabled={isSubmitting}>
                          Add
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    )}

                  </div>
                </Form>
              </div>

              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      {clientAccess() &&
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Group <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">

                                <Select
                                  className="basic-single custom-select-style"
                                  classNamePrefix="custom-select-style-inner"
                                  name="clientGroup"
                                  //onInputChange={this.handleChange}
                                  onChange={(e) => {
                                    this.handleChangeLandlordGroup(
                                      e,
                                      "change_client_group"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.groupName,
                                    value: this.state.initialValues.groupId,
                                  }}
                                  options={this.state.LandlordGroups.map(
                                    (item) => ({
                                      label: item.group_name,
                                      value: item.id,
                                    })
                                  )}
                                />

                                <ErrorMessage
                                  name="clientGroup"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {clientAccess() &&
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Name <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Select
                                  className="basic-single custom-select-style"
                                  classNamePrefix="custom-select-style-inner"
                                  name="clientName"
                                  onChange={(e) => {
                                    this.handleChangeLandlordGroup(
                                      e,
                                      "change_client_name"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.clientName,
                                    value: this.state.initialValues.clientId,
                                  }}
                                  options={this.state.clientList.map((item) => ({
                                    label: item.client_name,
                                    value: item.id,
                                  }))}
                                />
                                <ErrorMessage
                                  name="clientName"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Name <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="text" name="clause_name" />
                              <ErrorMessage
                                name="clause_name"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Effective From <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="date" name="effective_from" />
                              <ErrorMessage
                                name="effective_from"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.checkDelete(e);
                                }}
                              >
                                Delete
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                <Link to="/masters/commercial-clauses">
                                  Reset
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Add
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Are you sure you want to delete this item?"
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
        <CommercialClausesTable />
      </>
    );
  }
}

export default withRouter(CommercialClauses);
